<template>
  <v-btn
    v-bind="mappedProps"
    class="soraban-button"
    @click="$emit('click')"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'SorabanButton',
  props: {
    color: {
      required: false,
      default: 'primary',
      type: String,
      validator: p => ['primary', 'grey', 'error'].includes(p),
    },
    size: {
      required: false,
      type: String,
      default: '',
      validator: p => ['', 'small', 'large'].includes(p),
    },
    block: {
      required: false,
      default: false,
      type: Boolean,
    },
    variation: {
      required: false,
      type: String,
      default: '',
      validator: p =>
        ['', 'clear', 'icon', 'outline', 'pill', 'fab'].includes(p),
    },
  },
  computed: {
    mappedProps() {
      const props = {};

      props.color = this.color;
      props.block = this.block;

      if (this.size === 'small') {
        props.small = true;
      }
      if (this.size === 'large') {
        props.large = true;
      }
      if (this.variation === 'clear') {
        props.flat = true;
      }
      if (this.variation === 'icon' || this.variation === 'fab') {
        props.icon = true;
        props.flat = true;
        props.color = 'grey'; // for neutral hover state
      }
      if (this.variation === 'outline') {
        props.outline = true;
      }
      if (this.variation === 'pill') {
        props.round = true;
      }

      return props;
    },
  },
};
</script>

<style>
.soraban-button.v-btn {
  margin: 0 8px 8px;
}
</style>

<style scoped lang="postcss">
.soraban-button {
  font-weight: 600;
  text-transform: none;
  font-size: var(--type-interface);

  &.v-btn--small {
    font-size: calc(var(--type-interface) - 1px);
  }
  &.v-btn--large {
    font-size: calc(var(--type-interface) + 1px);
  }

  &:not(.v-btn--round):not(.v-btn--icon) {
    border-radius: 3px;
    &:before {
      border-radius: 0;
    }
  }

  &.grey {
    /* Vuetify override to make the text white because our grey buttons are darker than vuetify expects  */
    color: var(--color-white);
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
    font-style: italic;
    &:not(.v-btn--icon) {
      background-color: var(--color-grey) !important;
    }
  }

  &:not(.v-btn--small):not(.v-btn--large) {
    min-height: var(--button-height--default);
  }

  /*
    Vuetify overrides
  */
  &:hover:before,
  &:focus:before {
    /* Darken hover rather than lighten */
    background-color: var(--color-black);
  }

  &.v-btn--flat:hover:before,
  &.v-btn--flat:focus:before {
    background-color: currentColor;
  }

  &.v-btn--outline:hover >>> .v-btn__content,
  &.v-btn--outline:focus >>> .v-btn__content {
    color: var(--color-white);
  }
  &.v-btn--outline:hover:before,
  &.v-btn--outline:focus:before {
    background-color: currentColor;
    opacity: 8;
  }

  &:not(&--depressed):not(&--flat) {
    box-shadow: var(--box-shadow--default);
  }
}
</style>
